import React from 'react'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './InformationModal.module.scss'

export const InformationModal = ({
  confirmLabel,
  message,
  text,
  title,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    {...{ confirmLabel, title, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        variant="info"
        isInitialised
        {...{ message }}
      />
      <p className={styles.text}>{text}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
